import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider } from './auth'
import { AdminConsole, AdminOverview, AdminAccess, AdminActivity } from './Admin'
import { AdminModelExplorer } from './ModelExplorer'
import { AdminChainTree } from './ChainTree'
import { AdminDataBenchmark } from './DataBenchmark'
import { AdminBenchmark } from './Benchmark'
import { AdminLoginPage, RequireAdmin, RequireUser, UserLoginPage } from './AuthViews'
import Configurator from './Configurator'

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<UserLoginPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<RequireAdmin><AdminConsole /></RequireAdmin>}>
            <Route index element={<AdminOverview />} />
            <Route path="model" element={<AdminModelExplorer />} />
            <Route path="tree" element={<AdminChainTree />} />
            <Route path="benchmark" element={<AdminBenchmark />} />
            <Route path="validation" element={<AdminDataBenchmark />} />
            <Route path="activity" element={<AdminActivity />} />
            <Route path="access" element={<AdminAccess />} />
          </Route>
          <Route path="/" element={<RequireUser><Configurator /></RequireUser>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
